import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { errorMessage } from '@/components/Toast';
import { Button, Field, Input } from '@/components/ui';
import { AuthAside } from './AuthAside';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.auth.resetPassword(token ?? '', password);
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <AuthAside />
      <div className="auth-main">
        <div className="auth-card">
          <p className="eyebrow">Account recovery</p>
          <h1 >Choose a new password</h1>

          {!token ? (
            <p>
              This password-reset link is invalid.{' '}
              <Link to="/forgot-password" className="inline-link">Request a fresh one</Link>.
            </p>
          ) : done ? (
            <p>
              Your password has been reset.{' '}
              <Link to="/login" className="inline-link">Sign in</Link> with your new password.
            </p>
          ) : (
            <>
              <form className="stack gap-4" onSubmit={onSubmit}>
                <Field label="New password" hint="At least 8 characters.">
                  <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" placeholder="••••••••" required minLength={8} autoFocus />
                </Field>
                <Field label="Confirm new password" error={error ?? undefined}>
                  <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" placeholder="••••••••" required minLength={8} />
                </Field>
                <Button type="submit" className="block" loading={busy}>Reset password</Button>
              </form>
              {error && (
                <p className="muted mt-4 t-sm">
                  Link expired? <Link to="/forgot-password" className="inline-link">Request a fresh one</Link>.
                </p>
              )}
            </>
          )}

          <p className="muted mt-5 t-sm">
            Remembered it? <Link to="/login" className="inline-link">Back to sign in</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
